"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plugins = exports.defaultOptions = void 0;
var cssFunctions_1 = require("./cssFunctions");
var plugins_1 = require("./plugins");
exports.defaultOptions = {
    isRTL: false,
    isMobile: false,
    usesCssPerBreakpoint: false,
    strictMode: true,
};
exports.plugins = new plugins_1.Plugins();
Object.keys(cssFunctions_1.cssFunctions).forEach(function (funcName) { return exports.plugins.addCssFunction(funcName, cssFunctions_1.cssFunctions[funcName]); });
//# sourceMappingURL=common.js.map